import _ from "lodash"
import { getSession, getCurrentUser } from "../../helpers/AuthType/authService"

import { fnSsnTestSubjectVerification } from "../../helpers/Application/applicationService"

// Formik validation
import * as Yup from "yup"
//Global Functions
import {
  privateKey,
  decrypt,
  fnGetDateTime,
  dateformat,
  USDFormat,
  regexp,
} from "../global/functions.js"

//Import selects arrays
import {
  getStates,
  getIncomeTypes,
  getResidencyLength,
  getResidencyStatus,
  getIsJoint,
} from "../selects"

const MAX_FILE_SIZE = process.env.REACT_APP_MAXFILESIZE

const getSelectObject = (selectOptions, value) => {
  return selectOptions.filter(option => option.value == value)
}

export const getPersonalInfomationValidationSchema = applicantType => {
  try {
    let { app, merchant } = getSession()

    if (merchant.tu_testmode)
      regexp.ssn = /^(?!000)[0-9][0-9]{2}\-?(?!00)[0-9]{2}\-?(?!0000)[0-9]{4}$/

    if (!_.has(app, applicantType)) {
      app[applicantType] = {}
    }

    let applicant = app

    let applicantid = applicantType == "coapplicant" ? 2 : 1

    let state = _.has(applicant, "state")
      ? getSelectObject(getStates(), applicant["state"])
      : ""

    return {
      // enableReinitialize : use this flag when initial values needs to be changed
      enableReinitialize: true,

      initialValues: {
        key: applicantType,
        pin:
          _.has(applicant, "pin") && applicant["pin"]
            ? applicant["pin"]
            : getCurrentUser()._pin,
        code:
          _.has(applicant, "code") && applicant["code"]
            ? applicant["code"]
            : getCurrentUser()._code,
        companyid:
          _.has(applicant, "companyid") && applicant["companyid"]
            ? applicant["companyid"]
            : getCurrentUser()._companyid,
        applicantid: applicantid,
        firstname: _.has(applicant, "firstname") ? applicant["firstname"] : "",
        lastname: _.has(applicant, "lastname") ? applicant["lastname"] : "",
        ssn: _.has(applicant, "ssn") ? applicant["ssn"] : "",
        birthdate: _.has(applicant, "birthdate") ? applicant["birthdate"] : "",
        email: _.has(applicant, "email") ? applicant["email"] : "",
        cellphone: _.has(applicant, "cellphone") ? applicant["cellphone"] : "",
        homephone: _.has(applicant, "homephone") ? applicant["homephone"] : "",
        workphone: _.has(applicant, "workphone") ? applicant["workphone"] : "",
        addr: _.has(applicant, "addr") ? applicant["addr"] : "",
        addr2:
          _.has(applicant, "addr2") && applicant["addr2"]
            ? applicant["addr2"]
            : "",
        city: _.has(applicant, "city") ? applicant["city"] : "",
        state: _.isArray(state) ? state[0] : "",
        zipcode: _.has(applicant, "zipcode") ? applicant["zipcode"] : "",
      },
      validationSchema: Yup.object({
        key: Yup.string().required("Processing Error. Applicant type required"),
        //applicantid: Yup.string().required("Processing Error. Applicant type id required"),
        pin: Yup.string().required("user pin required"),
        code: Yup.string().required("user code required"),
        companyid: Yup.string().required("user companyid required"),

        firstname: Yup.string()
          .nullable()
          .max(50, "Maximum of 50 characters")
          .required("Please Enter First Name"),
        lastname: Yup.string()
          .nullable()
          .required("Please Enter Last Name")
          .max(50, "Maximum of 50 characters"),
        ssn: Yup.string()
          .nullable()
          .required("Please Enter SSN")
          .max(11, "Invalid Social Security Number")
          .matches(regexp.ssn, "Invalid Social Security Number")
          // .test({
          //   name: "itin",
          //   //exclusive: false,
          //   //message: "Invalid Social Security Number. ITIN not allowed",
          //   test: (value, ctx) => {
          //     if (regexp.itin.test(value)){
          //       return ctx.createError({
          //         message: "Invalid Social Security Number. ITIN not allowed",
          //       })
          //     }
          //     return true;
          //   },

          // })
          .test(
            "itin",
            "Invalid Social Security Number. ITIN not allowed",
            value => {
              if (!value) return true // skip validation if the value is not provided (handled by required rule)
              return !regexp.itin.test(value) // return false if it matches the ITIN pattern
            }
          )
          .min(9, "Invalid Social Security Number"),
        birthdate: Yup.string()
          .nullable()
          .required("Please Enter Birth Date")
          .matches(regexp.date, "Please Input Valid Birth Date"),
        email: Yup.string()
          .nullable()
          .email("Please Enter a valid Email Address")
          .required("Please Enter Email Address"),
        cellphone: Yup.string()
          .nullable()
          .required("Please Enter Cell Pnone")
          .matches(
            regexp.phone,
            "Invalid phone format. options: [9999999999, 999-999-9999, (999) 999-9999, +19999999999]"
          ),
        homephone: Yup.string()
          .nullable()
          .required("Please Enter Home Phone")
          .matches(
            regexp.phone,
            "Invalid phone format. options: [9999999999, 999-999-9999, (999) 999-9999, +19999999999]"
          ),
        workphone: Yup.string()
          .nullable()
          .required("Please Enter Work Phone")
          .matches(
            regexp.phone,
            "Invalid phone format. options: [9999999999, 999-999-9999, (999) 999-9999, +19999999999]"
          ),
        addr: Yup.string()
          .nullable()
          .required("Please Enter Address")
          .max(50, "Maximum of 50 characters"),
        addr2: Yup.string()
          .nullable()
          .max(50, "Maximum of 50 characters")
          .max(50, "Maximum of 50 characters"),
        city: Yup.string()
          .nullable()
          .required("Please Enter City")
          .max(50, "Maximum of 50 characters"),
        state: Yup.object().shape({
          value: Yup.string()
            .max(2, "Invalid State")
            .required("Please Enter State"),
          label: Yup.string(),
        }),
        //.nullable()
        //.required("Please Enter State"),
        zipcode: Yup.string()
          .nullable()
          .required("Please Enter Zipcode")
          .matches(regexp.zipcode, "Invalid Zipcode"),
      }),
    }
  } catch (error) {
    console.log(error.message)
  }
}

export const getIncomeInfomationValidationSchema = (
  applicantType,
  incomeTypeid
) => {
  let { app: applicant } = getSession()

  if (!incomeTypeid)
    incomeTypeid = applicant.hasOwnProperty("income_typeid")
      ? applicant["income_typeid"]
      : ""

  const incomeType = getSelectObject(getIncomeTypes(), incomeTypeid)

  let state =
    _.has(applicant, "job_state") && applicant.job_state
      ? getSelectObject(getStates(), applicant.job_state)
      : ""

  let schema = {}

  if (incomeTypeid == 1) {
    schema = {
      income_desc: Yup.string().nullable(),
      employer: Yup.string()
        .nullable()
        .required("Please Enter employer name")
        .max(50, "Maximum of 50 characters"),
      occupation: Yup.string()
        .nullable()
        .required("Please Enter occupation")
        .max(50, "Maximum of 50 characters"),
      months_of_employment: Yup.string()
        .nullable()
        .required("Please Enter months employed")
        .matches(/^[0-9]{1,3}$/, "Invalid number of months employed"),
      job_addr: Yup.string()
        .nullable()
        .required("Please Enter employment address")
        .max(50, "Maximum of 50 characters"),
      job_city: Yup.string()
        .nullable()
        .required("Please Enter employment city")
        .max(50, "Maximum of 50 characters"),
      job_state: Yup.object().shape({
        value: Yup.string()
          .required("Please Enter employment State")
          .max(2, "Invalid State"),
        label: Yup.string(),
      }),
      job_zip: Yup.string()
        .nullable()
        .required("Please Enter employment zipcode")
        .matches(regexp.zipcode, "Invalid Zipcode"),
      job_phone: Yup.string()
        .nullable()
        .required("Please Enter employment phone#")
        .matches(
          regexp.phone,
          "Invalid phone format. options: [9999999999, 999-999-9999, (999) 999-9999, +19999999999]"
        ),
    }
  } else {
    schema = {
      income_desc: Yup.string()
        .nullable()
        .required("Please Enter income description")
        .max(255, "Maximum of 255 characters"),
      employer: Yup.string(),
      occupation: Yup.string(),
      months_of_employment: Yup.string(),
      job_addr: Yup.string(),
      job_city: Yup.string(),
      job_state: Yup.string(),
      job_zip: Yup.string(),
      job_phone: Yup.string(),
    }
  }

  schema.key = Yup.string().required(
    "Processing Error. Applicant type required"
  )
  schema.income_typeid = Yup.object().shape({
    value: Yup.string()
      .required("Please Enter Income Type")
      .matches(/^[0-9]{1,2}$/, "Invalid income type"),
    label: Yup.string(),
  })
  schema.salary = Yup.string()
    .required("Please Enter Monthly Income")
    .matches(/^\d+(\.\d+)?$/, "Invalid monthly income")
  schema.household_income = Yup.string()
    .required("Please Enter house hold income")
    .matches(/^\d+(\.\d+)?$/, "Invalid household income")

  return {
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      key: applicantType,
      household_income: _.has(applicant, "household_income")
        ? applicant["household_income"]
        : "",
      income_typeid:
        _.isArray(incomeType) && !_.isEmpty(incomeType) ? incomeType[0] : "",
      income_desc:
        _.has(applicant, "income_desc") && incomeTypeid && incomeTypeid != 1
          ? applicant["income_desc"]
          : "",
      salary: _.has(applicant, "salary") ? applicant["salary"] : "",
      employer:
        _.has(applicant, "employer") && incomeTypeid == 1
          ? applicant["employer"]
          : "",
      occupation:
        _.has(applicant, "occupation") && incomeTypeid == 1
          ? applicant["occupation"]
          : "",
      months_of_employment:
        _.has(applicant, "months_of_employment") && incomeTypeid == 1
          ? applicant["months_of_employment"]
          : "",
      job_addr:
        _.has(applicant, "job_addr") && incomeTypeid == 1
          ? applicant["job_addr"]
          : "",
      job_city:
        _.has(applicant, "job_city") && incomeTypeid == 1
          ? applicant["job_city"]
          : "",
      job_state:
        _.isArray(state) && !_.isEmpty(state) && incomeTypeid == 1
          ? state[0]
          : "", //
      job_zip:
        _.has(applicant, "job_zip") && incomeTypeid == 1
          ? applicant["job_zip"]
          : "",
      job_phone:
        _.has(applicant, "job_phone") && incomeTypeid == 1
          ? applicant["job_phone"]
          : "",
    },
    validationSchema: Yup.object(schema),
  }
}

export const getResidencyInfomationValidationSchema = (
  applicantType,
  residenceLength,
  residenceStatus
) => {
  let { app: applicant } = getSession()

  if (!residenceLength)
    residenceLength =
      _.has(applicant, "residence_length") && applicant.residence_length
        ? applicant.residence_length
        : 0

  const residency = getSelectObject(getResidencyLength(), residenceLength)

  let state =
    _.has(applicant, "prev_state") && applicant.prev_state
      ? getSelectObject(getStates(), applicant.prev_state)
      : ""

  if (!residenceStatus)
    residenceStatus = applicant["homeownershipid"]
      ? applicant["homeownershipid"]
      : 0
  let homeownership = getSelectObject(getResidencyStatus(), residenceStatus)

  let schema = {}

  if (residenceLength == 1) {
    schema = {
      prev_addr: Yup.string()
        .nullable()
        .required("Please Enter Previous Residency Address")
        .max(50, "Maximum of 50 characters"),
      prev_city: Yup.string()
        .nullable()
        .required("Please Enter Previous Residency City")
        .max(50, "Maximum of 50 characters"),
      prev_state: Yup.object().shape({
        value: Yup.string()
          .required("Please Enter Previous Residency State")
          .max(2, "Invalid State"),
        label: Yup.string(),
      }),
      prev_zip: Yup.string()
        .nullable()
        .required("Please Enter Previous Residency Zipcode")
        .matches(regexp.zipcode, "Invalid Zipcode"),
    }
  } else {
    schema = {
      prev_addr: Yup.string(),
      prev_city: Yup.string(),
      prev_state: Yup.string(),
      prev_zip: Yup.string(),
    }
  }

  schema.key = Yup.string().required(
    "Processing Error. Applicant type required"
  )

  schema.homeownershipid = Yup.object().shape({
    value: Yup.string()
      .required("Please Enter Residency Status")
      .matches(/^[1-2]$/, "Invalid Residency Status"),
    label: Yup.string(),
  })

  schema.residence_length = Yup.object().shape({
    value: Yup.string()
      .required("Please Enter Residency Length")
      .matches(/^[1-2]$/, "Invalid Residency Status"),
    label: Yup.string(),
  })

  schema.mortgage = Yup.string()
    .required("Please Enter monthly morgage/rent payment")
    .matches(/^\d+(\.\d+)?$/, "Invalid format")

  return {
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      key: applicantType,
      homeownershipid:
        _.isArray(homeownership) && !_.isEmpty(homeownership)
          ? homeownership[0]
          : "",
      mortgage:
        _.has(applicant, "mortgage") && /^\d+(\.\d+)?$/.test(applicant.mortgage)
          ? Number(applicant.mortgage).toFixed(2)
          : "",
      residence_length:
        _.isArray(residency) && !_.isEmpty(residency) ? residency[0] : "",

      prev_addr:
        _.has(applicant, "prev_addr") &&
        applicant.prev_addr &&
        residenceLength == 1
          ? applicant.prev_addr
          : "",
      prev_city:
        _.has(applicant, "prev_city") &&
        applicant.prev_city &&
        residenceLength == 1
          ? applicant.prev_city
          : "",
      prev_state: _.isArray(state) && residenceLength == 1 ? state[0] : "", //
      prev_zip:
        _.has(applicant, "prev_zip") &&
        applicant.prev_zip &&
        residenceLength == 1
          ? applicant.prev_zip
          : "",
    },
    validationSchema: Yup.object(schema),
  }
}

export const getReferencesValidationSchema = applicantType => {
  let { app: applicant } = getSession()

  let schema = {}

  schema.key = Yup.string().required(
    "Processing Error. Applicant type required"
  )

  schema.relative1_fullname = Yup.string()
    .nullable()
    .required("Please enter reference name")
    .max(50, "Maximum of 50 characters")

  schema.relative1_phone = Yup.string()
    .nullable()
    .required("Please enter reference phone")
    .matches(
      regexp.phone,
      "Invalid phone format. options: [9999999999, 999-999-9999, (999) 999-9999, +19999999999]"
    )

  return {
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      key: applicantType,
      relative1_fullname:
        _.has(applicant, "relative1_fullname") && applicant.relative1_fullname
          ? applicant.relative1_fullname
          : "",
      relative1_phone:
        _.has(applicant, "relative1_phone") && applicant.relative1_phone
          ? applicant.relative1_phone
          : "",
    },
    validationSchema: Yup.object(schema),
  }
}

export const getAccessCodeSchema = applicantType => {
  return {
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      key: applicantType,
      access_code_method: "",
    },
    validationSchema: Yup.object({
      key: Yup.string().required("Processing Error. Applicant type required"),
      access_code_method: Yup.object()
        .shape({
          value: Yup.string().required("Please Select a delivery option"),
          label: Yup.string(),
        })
        .nullable(),
    }),
  }
}

export const getValidateAccessCodeSchema = applicantType => {
  let { app } = getSession()

  let applicant = app

  return {
    enableReinitialize: true,
    initialValues: {
      key: applicantType,
      access_code: "",
    },
    validationSchema: Yup.object({
      key: Yup.string().required("Processing Error. Applicant type required"),
      access_code: Yup.string()
        .required("Access code required to continue")
        .oneOf(
          [String(decrypt(applicant.access_code_encrypted))],
          "Invalid access code"
        ),
    }),
  }
}

export const getInviteCoEmailSchema = ({
  url_identifier,
  firstname,
  lastname,
  email,
}) => {
  return {
    enableReinitialize: true,
    initialValues: {
      url_identifier,
      firstname,
      lastname,
      email,
    },
    validationSchema: Yup.object({
      url_identifier: Yup.string()
        .nullable()
        .required("System error. identifier missing"),
      firstname: Yup.string()
        .nullable()
        .max(50, "Maximum of 50 characters")
        .required("First Name is required"),
      lastname: Yup.string()
        .nullable()
        .max(50, "Maximum of 50 characters")
        .required("Last Name is required"),
      email: Yup.string()
        .nullable()
        .email("Please Enter a valid Email Address")
        .required("Email Address is required"),
    }),
  }
}

export const getInviteCoSmsSchema = ({
  url_identifier,
  firstname,
  lastname,
  cellphone,
}) => {
  return {
    enableReinitialize: true,
    initialValues: {
      url_identifier,
      firstname,
      lastname,
      cellphone,
    },
    validationSchema: Yup.object({
      url_identifier: Yup.string()
        .nullable()
        .required("System error. identifier missing"),
      firstname: Yup.string()
        .nullable()
        .max(50, "Maximum of 50 characters")
        .required("First Name is required"),
      lastname: Yup.string()
        .nullable()
        .max(50, "Maximum of 50 characters")
        .required("Last Name is required"),
      cellphone: Yup.string()
        .nullable()
        //.max(11, "Maximum of 11 characters")
        .required("Cell Phone is required")
        .matches(regexp.phone, "Invalid phone format."),
    }),
  }
}
